//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from "moment";
import BackendServices from "@/services/backend-services";
import { required } from "@/utils/validations.js";
import { noValidation } from "@/utils/validations.js";

export default {
  name: "GeographyTab",
  props: ["value", "refData", "create"],
  mounted() {
    BackendServices.getGeographyHierarchyLevels().then((response) => {
      this.classAggregatorList = [
        { id: null, name: "Sem Agregador", parent_id: null },
      ].concat(response.data);
    });
  },
  data: function () {
    return {
      moment,
      validForm: false,
      hierarchyLevels: [],
      hierarchyLevelElements: [],
      classLevelName:
        this.create === false
          ? this.value.level_id != null
            ? this.value.level.name
            : null
          : "",
      classAggregatorLevel:
        this.create === false
          ? this.value.level.parent_id != null
            ? this.value.level.parent.name
            : "N/A"
          : "",
      designationAggregatorLevel:
        this.create === false ? this.value.parent_id : null,
      designationAggregatorLevelList:
        this.create === false
          ? [{ id: null, name: "Sem Agregador", parent_id: null }].concat(
            this.refData.filter(
              (e) => e.level_id === this.value.level.parent_id
            )
          )
          : [{ id: null, name: "Sem Agregador", parent_id: null }],
      classAggregatorList: [
        { id: null, name: "Sem Agregador", parent_id: null },
      ],
    };
  },
  methods: {
    required,
    noValidation,
    updateDataOnLevel(event) {
      if (this.create) {
        const classLevel = this.classAggregatorList.find((e) => e.id === event);
        this.value.level = classLevel;
        this.designationAggregatorLevelList = [
          { id: null, name: "Sem Agregador", parent_id: null },
        ].concat(
          this.refData.filter((e) => e.level_id === this.value.level.parent_id)
        );
      }
      this.$emit("value", this.value);
    },
    updateData() {
      this.$emit("value", this.value);
    },
    validateData: function () {
      this.$refs.form.validate().then((success) => {
        if (success) {
          this.validForm = true;
          this.$emit("form-valid", this.validForm);
        } else {
          this.validForm = false;
          this.$emit("form-invalid", this.validForm);
        }
      });
    },
  },
  watch: {
    value: {
      handler: function () {
        this.designationAggregatorLevelList = [{ id: null, name: "Sem Agregador", parent_id: null }].concat(this.refData.filter(e => e.level_id === this.value.level.parent_id));
      },
      deep: true,
    },
  },
};
